import { render, staticRenderFns } from "./AdditionalCompliance.vue?vue&type=template&id=7ad3a7e5&scoped=true&"
import script from "./AdditionalCompliance.vue?vue&type=script&lang=js&"
export * from "./AdditionalCompliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad3a7e5",
  null
  
)

export default component.exports